// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedPapers-cls1_sIk","cls2":"RelatedPapers-cls2_3Kn RelatedPapers-cls1_sIk"};